export class Plesso {
  id;
  codice;
  denominazione;
  ordine;
  gestione;
}
